import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { getCurrentDateTimeLocal } from "../../helpers/getcurrenttimelocal";
import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { StockServices } from "../../services/stockServices";
import { supplierservices } from "../../services/supplierServices";
import {useStock} from '../../contexts/stockContexts'; 
import {HandleClose} from '../../helpers/formclose';
import {
  Titlebar,
  Searchbox,
  Label,
  Stockstatus,
  Stockstatusavailability,
  Importexceldata,
} from "../../components/fieldsComp";
import { useParams, useNavigate, useLocation } from "react-router";
import { Submissionbtn } from "../../components/buttons";
import { Formik, Field, Form } from "formik";
import { useSelector } from "react-redux";
import { Loaderoverlay } from "../../components/loaderComp";

const Quickupdatestock = () => {
  const { id } = useParams();
  const location = useLocation();
  const unitreducer = useSelector((state) => state.unitreducer);
  const currencyreducer = useSelector((state) => state.currencyreducer);
  const [supllierlist, setSupllierlist] = useState([]);
  const [submitted, setSubmitted] = useState(true);
  const [units, setUnits] = useState([]);
  const [users, setUsers] = useState([]);
  const [userloaded, setUserloaded] = useState(true);
  const toast = useRef(null);
  const [componentytpe, setComponenttype] = useState("product");
  const [components, setComponents] = useState([]);
  const [products, setProducts] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [defaultstate, setDefaultstate] = useState({});
  const [purchasedataresult, setPurchasedataresult] = useState({});
  const [formfielddisable, setFormfielddisable] = useState({
    unitproduced: false,
    perunitprice: false,
  });
  const [loading, setLoading] = useState(true);
  const {updateStock,settingsdata,getSettingValue} = useStock();
  const [warehouses, setWarehouses] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(false);
        await Promise.all([
          getcomponents(),
          getbulkproduct(),
          // getspecificproduct(id);
          getunits(),
          getsupplier(),
          getcurrency(),
        ]);

        let stocktype = location.state.stocktype;
        if (
          location.state.purchaseorder != undefined &&
          location.state.purchaseorder == "yes"
        ) {
          // console.log("running");
          //   console.log(location.state.value);
          //   console.log(location.state.purchaseorder);
          let totalcost =
            location.state.value.actualquantity *
            location.state.value.unitprice;
          let purchasedefault = {
            stocktype: "component",
            unit_of_measurement: location.state.value.unit,
            stock_date: getCurrentDateTimeLocal(),
            ponumber: location.state.value.ponumber,
            quantity: location.state.value.actualquantity,
            purchase_price: location.state.value.unitprice,
            total_cost: totalcost,
            product: location.state.value.componentSkuCode,
            supplier_id: location.state.value.supplier,
            purchase_currency:  location.state.value.currency ?? getSettingValue('default_currency'),
            totalcost_currency:  location.state.value.currency ?? getSettingValue('default_currency'),
            unit_of_measurement:'unit',
            production_type:'purchased',
           

          };
          setFormData({ stocktype: "component" });
          setDefaultstate(purchasedefault);
          setFormfielddisable({
            unitproduced: true,
            perunitprice: true,
          });
          setLoading(true);
        } else {
          setFormData({ stocktype: stocktype });
          setDefaultstate((prevData) => {
            return {
              ...location.state,
              quantity: "",
              // purchase_price:'',
              total_cost: "",
              stock_date: getCurrentDateTimeLocal(),
              ponopresent:'no',
              production_type:'in_house',
              batch_number:'BATCH-'+Math.floor(100000 + Math.random() * 900000),

            };
          });
        }

        setLoading(true);
      } catch (e) {
        console.log(e);
      }
    };

    fetchData();
    getWarehouseDetails();
    // setComponenttype(stocktype);
    // console.log(location);
  }, []);

  const [formData, setFormData] = useState({
    id: "",
    product_name: "",
    sku_code: "",
    stock_on_hand: "",
    stock_needed: "",
    discrepancy_alert: "", // boolean: can be true/false or 'true'/'false'
    restock_alert_threshold: "",
    stock_location: "",
    stock_type: "", // 'finished' or 'component'
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setComponenttype(formData.stocktype);
  }, [formData.stocktype]);

  const handleSave = (values) => {
    // console.log('Form Data:', values);
    // return;
    // Add your save logic here
    setSubmitted(false);
    StockServices.addstock(values)
      .then((response) => {
        // console.log(response);
        if (response.status == 200) {
          setSubmitted(true);
          // const randomNum = Math.random();
          // updateStock(randomNum);
          toast.current.show({
            severity: "success",
            summary: "Stock",
            detail: `${response.data.data}`,
          });
        } else {
          setSubmitted(true);
          toast.current.show({
            severity: "error",
            summary: "Stock",
            detail: `${response.data.data}`,
          });
        }
      })
      .catch((error) => {
        setSubmitted(true);
        toast.current.show({
          severity: "error",
          summary: "Stock",
          detail: "Error",
        });
      });
  };


  const getWarehouseDetails = () => {
      StockServices.getWorhouseData().then((response)=>{
        if(response.status == 200){
          setWarehouses(response.data.data);
        }else{
          setWarehouses([]);
        }
      }).catch((error) => {
        console.log("error: " , error);
      })
    }

const displayWarehouseLocation = () =>{
  let items = [];
  warehouses.forEach((value, index) => {
    if(value.is_active == 1){
        items.push(<option key={index} value={value.warehouse_code}>{value.name}</option>);   
    }
    
  })

  return items;
}

  const handleClose = () => {
    // Reset form or close modal logic
    console.log("Form Closed");
  };

  function Componenttype(stocktype) {
    let component = <></>;
    let componentsdesign = [];
    components.forEach((value, index) => {
      componentsdesign.push(
        <option value={value.componentSkuCode}>{value.component}</option>
      );
    });

    let productsdesign = [];
    products.forEach((value, index) => {
      productsdesign.push(
        <option value={value.sku_code}>{value.product_name}</option>
      );
    });

    if (stocktype == "component") {
      component = (
        <Field
          as="select"
          name="product"
          className="form-control"
          placeholder="Select Component"
          required
        >
          <option value="">Select Component</option>
          {componentsdesign}
        </Field>
      );
    } else {
      component = (
        <Field
          as="select"
          name="product"
          className="form-control"
          placeholder="Select Product"
          required
        >
          <option value="">Select Product</option>
          {productsdesign}
        </Field>
      );
    }

    return component;
  }

  const getspecificproduct = (id) => {
    // setUserloaded(false);
    productservices
      .getspecificproduct(id)
      .then((response) => {
        if (response.status == 200) {
          setFormData(response.data.data);
          //   console.log(response.data.data);
          //     setUsers(response.data.data);
          //     setUserloaded(true);
        } else {
          // setUsers([]);
          // setUserloaded(true);
        }
      })
      .catch((error) => {
        // setUsers([]);
        // setUserloaded(true);
      });
  };

  const getunits = () => {
    unitreducer
      .then((response) => {
        //  console.log(response);
        setUnits(response);
      })
      .catch((error) => {});
  };

  const getsupplier = () => {
    setLoading(false); 
    supplierservices
      .getbulkdata("all", "1", "25")
      .then((response) => {
        // console.warn(response);
        if (response.status == 200) {
          setSupllierlist(response.data.data);
          setLoading(true);
        } else {
          setSupllierlist([]);
          setLoading(true);
        }
      })
      .catch((error) => {
        setSupllierlist([]);
        setLoading(true);
      });
  };

  function displaySupplier2() {
    let supllierdata = [];
    supllierlist.forEach((value, index) => {
      supllierdata.push(<option value={value.id}>{value.name}</option>);
    });
    return supllierdata;
  }

  function displayUnits() {
    let unitsarr = [];
    units.forEach((value, index) => {
      unitsarr.push(<option value={value.short_code}>{value.name}</option>);
    });

    return unitsarr;
  }

  const getbulkproduct = () => {
    productservices
      .getbulkproduct("1", 25)
      .then((response) => {
        if (response.status == 200) {
          setProducts(response.data.data);
        } else {
          setProducts([]);
        }
      })
      .catch((error) => {
        setProducts([]);
      });
  };

  const getcomponents = () => {
    productservices
      .getcomponents("1", "25", "all")
      .then((response) => {
        if (response.status == 200) {
          setComponents(response.data.data);
        } else {
          setComponents([]);
        }
      })
      .catch((error) => {
        setComponents([]);
      });
  };

  function getCurrentDateTimeLocal() {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  }

  const getcurrency = () => {
    currencyreducer
      .then((response) => {
        // console.log("currency reducer");
        // console.log(response);
        setCurrencies(response);
      })
      .catch((error) => {});
  };

  const displayCurrency = () => {
    let items = [];
    currencies.forEach((value, index) => {
      items.push(
        <option key={index} value={value.code}>
          {value.code}
        </option>
      );
    });
    return items;
  };


  const componentDecide = (values,{fun}) => {
     if(defaultstate.stocktype == 'product'){
           return <div className="col-md-6 form-group">
            <div className="row">
              
                <div className="col-md-4">
                <Label name="Containing a PO no" />
                
                    <div className="flex-box">
                    <div className="form-check">
                    <Field
                        type="radio"
                        name="ponopresent"
                        value="yes"
                        className="form-check-input"
                        id="component"
                        onChange={(e) => {
                             fun("production_type", 'purchased');
                             fun("ponopresent", 'yes');
                        }}
                    />
                    <label
                        htmlFor="component"
                        className="form-check-label"
                    >
                        yes
                    </label>
                    </div>

                    <div className="form-check">
                    <Field
                        type="radio"
                        name="ponopresent"
                        value="no"
                        className="form-check-input"
                        id="component"
                        onChange={(e) => {
                             fun("production_type", 'in_house');
                             fun("ponopresent", 'no');
                        }}
                    />
                    <label
                        htmlFor="component"
                        className="form-check-label"
                    >
                        No
                    </label>
                    </div>
                </div>    
                </div>  
          
                {(values == 'yes') ? ( <div className="col-md-8">
                <Label name="Po Number" />
                <Field
                    type="text"
                    name="ponumber"
                    className="form-control"
                    placeholder="Enter Po Number"
                    required
                />
                </div>) : (<></>)}
                
            </div>
            </div>       
     }else{
           return <div className="col-md-6 form-group">
                <Label name="Po Number" />
                <Field
                    type="text"
                    name="ponumber"
                    className="form-control"
                    placeholder="Enter Po Number"
                    required
                />

           </div>       
     }     
  }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Stock / Quick Update"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}
        <Loaderoverlay isloaded={loading} />
        {/* <span style={{ display: "inline-block", width: "auto" }}>
          <Titlebar text={"Update Stock"} />
        </span>{" "} */}
        <span style={{ display: "inline-block", width: "auto" }}>
          {<Stockstatusavailability status={location.state.Instock} />}
        </span>
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4">
                  <Formik
                    // initialValues={location.state}
                    initialValues={defaultstate}
                    enableReinitialize={true}
                    onSubmit={async (values) => {
                      handleSave(values);
                    }}
                  >
                    {({ handleChange, setFieldValue, values }) => (
                      <Form>
                        <div className="row">
                          <div className="col-md-6 form-group">
                            <Label name="Stock Type" />
                            <Field
                              as="select"
                              name="stocktype"
                              className="form-control"
                              placeholder="Stock Type"
                              onChange={(e) => {
                                setFormData({ stocktype: e.target.value });
                                setFieldValue("stocktype", e.target.value); // Update Formik state
                              }}
                            >
                              <option value="">Select Stock type</option>
                              <option value="component">Component</option>
                              <option value="product">Product</option>
                            </Field>
                          </div>

                          <div className="col-md-6 form-group">
                            <Label name="Select Product" />
                            {Componenttype(componentytpe)}
                          </div>

                          <div className="col-md-6 form-group">
                            <Label name="Select Date" />
                            <Field
                              type="datetime-local"
                              name="stock_date"
                              className="form-control"
                              placeholder="Select Date"
                              required
                            />
                          </div>

                          <div className="col-md-6 form-group">
                            <Label name="Stock Type" />
                            <Field
                              as="select"
                              name="stock_status"
                              className="form-control"
                              required
                              onChange={(e) => {
                                setFieldValue("stock_status", e.target.value); // Update Formik state
                              }}
                            >
                              <option value="">Select Stock Status</option>
                              <option value="available">Available</option>
                              <option value="used">Used</option>
                              <option value="expired">Expired</option>
                              <option value="damaged">Damaged</option>
                            </Field>
                          </div>

                          <div className="col-md-6 form-group">
                            <Label name="Batch Number" />
                            <Field
                              type="text"
                              name="batch_number"
                              className="form-control"
                              placeholder="Enter Batch Number"
                              required
                            />
                          </div>

                          {/* // Po number */}
                          
                          {componentDecide(values.ponopresent,{fun:setFieldValue})}
                          <div className="col-md-6 form-group">
                            <Label
                              name="Current Total Stock"
                              classstyle="text-info"
                            />
                            <Field
                              type="number"
                              name="quantitysum"
                              className="form-control"
                              required
                              disabled
                            />
                          </div>

                          
                          <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                     <Label name="Production (In-house / Purchased)" />
                                        <Field
                                            as="select"
                                            name="production_type"
                                            className="form-control"
                                            required
                                            onChange={(e) => {
                                              setFieldValue("production_type", e.target.value);
                                              if(e.target.value == 'in_house'){
                                                setFieldValue("ponopresent", 'no');
                                              }else{
                                                 setFieldValue("ponopresent", 'yes');
                                              } 
                                               // Update Formik state
                                            }}
                                          >
                                            {/* <option value="">Select production type</option> */}
                                            <option value="purchased">Purchased</option>
                                            <option value="in_house">In House</option>
                                            
                                          </Field>

                                </div>
                                 <div className="col-md-6 form-group">
                                <Label name="Enter units produced or purchased" />
                                <Field
                                  type="number"
                                  name="quantity"
                                  className="form-control"
                                  placeholder="Unit Produced"
                                  required
                                  disabled={formfielddisable.unitproduced}
                                  onChange={(e) => {
                                    setFieldValue("quantity", e.target.value); // Update Formik state
                                    let total_cost =
                                      e.target.value * values.purchase_price;
                                    setFieldValue("total_cost", total_cost);
                                    // console.log(values.batch_number);
                                  }}
                                />
                              </div>
                            </div>
                           
                          </div>
                          

                          <div className="col-md-6 form-group">
                            <Label name="Unit of Measurement" />
                            <Field
                              as="select"
                              name="unit_of_measurement"
                              className="form-control"
                              required
                            >
                              <option value="">
                                Select Unit of Measurement
                              </option>
                              {displayUnits()}
                            </Field>
                          </div>

                          {/* Supplier ID */}
                          <div className="col-md-6 form-group">
                            <Label name="Supplier ID" />
                            <Field
                              as="select"
                              name="supplier_id"
                              className="form-control"
                              placeholder="Enter Supplier ID"
                              required
                            >
                              <option value="">Select Supplier</option>
                              {displaySupplier2()}
                            </Field>
                          </div>
                           
                          <p className="pt-3 text-success">Manufacturing & Production Costs : </p>          
                          <div className="row">
                            {/* Fill Cost */}
                            <div className="col-md-3 form-group">
                              <Label
                                name="Fill cost / Unit"
                                classstyle="text-info"
                                value="Fill Cost"
                                mandate = {false}
                                
                              />
                              <Field
                                type="number"
                                name="fill_cost"
                                step="0.01"
                                className="form-control"
                                placeholder="Enter Fill Cost"
                                onChange={(e) => {
                                  setFieldValue("fill_cost", e.target.value);
                                  // let total_cost =
                                  //   (e.target.value + values.co_pack_cost + values.manufacturing_service_charge + values.wastage_cost) * values.quantity;
                                  const fillCost = Number(e.target.value) || 0;
                                  let total_cost =
                                    fillCost +
                                    Number(values.co_pack_cost || 0) +
                                    Number(values.manufacturing_service_charge || 0) +
                                    Number(values.wastage_cost || 0);
                                    setFieldValue("purchase_price", total_cost * 1);
                                    total_cost = total_cost * values.quantity;  
  
                                    setFieldValue("total_cost", total_cost);
                                  
                                  // console.log(values.batch_number);
                                }}
                              />
                            </div>

                            {/* Co-Pack Cost */}
                            <div className="col-md-3 form-group">
                              <Label
                                name="Co pack cost / unit"
                                classstyle="text-info"
                                value="Co-Pack Cost"
                                mandate = {false}
                              />
                              <Field
                                type="number"
                                name="co_pack_cost"
                                step="0.01"
                                className="form-control"
                                placeholder="Enter Co-Pack Cost"
                                onChange={(e) => {
                                  setFieldValue("co_pack_cost", e.target.value);
                                  const co_pack_cost = Number(e.target.value) || 0;
                                  let total_cost =
                                    co_pack_cost +
                                    Number(values.fill_cost || 0) +
                                    Number(values.manufacturing_service_charge || 0) +
                                    Number(values.wastage_cost || 0);
                                    setFieldValue("purchase_price", total_cost * 1);
                                  total_cost = total_cost * values.quantity;  
  
                                  setFieldValue("total_cost", total_cost);
                                  
                                  // console.log(values.batch_number);
                                }}
                              />
                            </div>

                            {/* Manufacturing Service Charge */}
                            <div className="col-md-3 form-group">
                              <Label
                                name="Manufacturing Service charge / Unit"
                                classstyle="text-info"
                                value="Manufacturing Service Charge"
                                mandate = {false}
                              />
                              <Field
                                type="number"
                                name="manufacturing_service_charge"
                                step="0.01"
                                className="form-control"
                                placeholder="Enter Manufacturing Service Charge"
                                onChange={(e) => {
                                  setFieldValue("manufacturing_service_charge", e.target.value);
                                  const manufacturing_service_charge = Number(e.target.value) || 0;
                                  let total_cost =
                                    manufacturing_service_charge +
                                    Number(values.fill_cost || 0) +
                                    Number(values.co_pack_cost || 0) +
                                    Number(values.wastage_cost || 0);
                                    setFieldValue("purchase_price", total_cost * 1);
                                  total_cost = total_cost * values.quantity;  
  
                                  setFieldValue("total_cost", total_cost);
                                 
                                  // console.log(values.batch_number);
                                }}
                              />
                            </div>

                            {/* Wastage Cost */}
                            <div className="col-md-3 form-group">
                              <Label
                                name="Wastage cost / Unit"
                                classstyle="text-info"
                                value="Wastage Cost"
                                mandate = {false}
                              />
                              <Field
                                type="number"
                                name="wastage_cost"
                                step="0.01"
                                className="form-control"
                                placeholder="Enter Wastage Cost"
                                onChange={(e) => {
                                  setFieldValue("wastage_cost", e.target.value);
                                  const wastage_cost = Number(e.target.value) || 0;
                                  let total_cost = wastage_cost +
                                    Number(values.manufacturing_service_charge || 0) +
                                    Number(values.fill_cost || 0) +
                                    Number(values.co_pack_cost || 0);
                                    setFieldValue("purchase_price", total_cost * 1);
                                  total_cost = total_cost * values.quantity;  
  
                                  setFieldValue("total_cost", total_cost);
                                  
                                  
                                  // console.log(values.batch_number);
                                }}
                              />
                            </div>
                          </div>


                          {/* Purchase Price */}
                          <div className="col-md-6 form-group">
                            <Label
                              name="Cost per Unit (Production / Purchase)"
                              classstyle="text-info"
                            />
                            <div className="flex-box">
                              <Field
                                as="select"
                                name="purchase_currency"
                                className="form-control"
                                disabled={formfielddisable.perunitprice}
                                style={{ width: "100px" }}
                                onChange={(e) => {
                                  setFieldValue(
                                    "purchase_currency",
                                    e.target.value
                                  );
                                  setFieldValue(
                                    "totalcost_currency",
                                    e.target.value
                                  );
                                  // Update Formik state
                                }}
                              >
                                {displayCurrency()}
                              </Field>
                              <Field
                                type="number"
                                name="purchase_price"
                                step="0.01"
                                className="form-control"
                                placeholder="Enter Purchase Price"
                                disabled={formfielddisable.perunitprice}
                                onChange={(e) => {
                                  setFieldValue(
                                    "purchase_price",
                                    e.target.value
                                  ); // Update Formik state
                                  let total_cost =
                                    e.target.value * values.quantity;
                                  setFieldValue("total_cost", total_cost.toFixed(2));
                                }}
                              />
                            </div>
                          </div>

                          {/* Total Cost */}
                          <div className="col-md-6 form-group">
                            <Label name="Total Cost" />
                            <div className="flex-box">
                              <Field
                                as="select"
                                name="totalcost_currency"
                                className="form-control"
                                style={{ width: "100px" }}
                              >
                                {displayCurrency()}
                              </Field>

                              <Field
                                type="number"
                                name="total_cost"
                                step="0.01"
                                className="form-control"
                                placeholder="Enter Total Cost"
                                disabled
                              />
                            </div>
                          </div>

                          {/* Expiry Date */}
                          <div className="col-md-6 form-group">
                            <Label name="Expiry Date (Optional)" mandate={false}/>
                            <Field
                              type="date"
                              name="expiry_date"
                              className="form-control"
                              placeholder="Select Expiry Date"
                            />
                          </div>

                          {/* Warehouse Location */}
                          {/* <div className="col-md-6 form-group">
                            <div className="flex-box gap-2"><Label name="Warehouse Location"/> <span className="text-info"> Provide stock location details</span></div>
                            <Field
                              type="text"
                              name="warehouse_location"
                              className="form-control"
                              placeholder="Enter Warehouse Location"
                            />
                          </div> */}

                          <div className="col-md-6 form-group">
                            <Label name="Warehouse Location" />
                            {/* <Field
                            type="text"
                            name="warehouse_location"
                            className="form-control"
                            placeholder="Enter Warehouse Location"
                            /> */}
                            <Field as="select" name="warehouse_location" className="form-control" onChange={(e) => {
                               setFieldValue('warehouse_location',e.target.value);
                            }} >
                               <option value="">Select Warehouse</option>
                                {displayWarehouseLocation()}
                            </Field>   
                        </div>

                          {/* Notes */}
                          <div className="col-md-12 form-group">
                            <Label name="Notes" />
                            <Field
                              as="textarea"
                              name="notes"
                              className="form-control"
                              placeholder="Enter Notes"
                            />
                          </div>
                        </div>

                        <br></br>
                        {/* <br></br> */}
                        <div className="row">
                          <div className="col-md-6">
                            {/* <button
                                                            type="submit"
                                                            className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                                                        >
                                                            Save
                                                        </button> */}
                            <Submissionbtn issaved={submitted} />
                          </div>

                          {<HandleClose/>}
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Quickupdatestock;
